import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Shield, AlertTriangle } from 'lucide-react';

interface BlockedPageProps {
  blockedUntil: string;
  isGlobalBlock?: boolean;
}

export default function BlockedPage({ blockedUntil, isGlobalBlock = false }: BlockedPageProps) {
  const { t } = useTranslation('blocked');
  const [timeLeft, setTimeLeft] = useState<string>('');

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const blockEnd = new Date(blockedUntil).getTime();
      
      console.log('Calculating time left:', {
        now: new Date(now).toISOString(),
        blockEnd: new Date(blockEnd).toISOString(),
        difference: blockEnd - now
      });

      const difference = blockEnd - now;

      if (difference <= 0) {
        console.log('Block has expired, reloading page');
        window.location.reload();
        return '';
      }

      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      console.log('Time remaining:', { minutes, seconds });

      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };

    // Initial calculation
    const initialTimeLeft = calculateTimeLeft();
    console.log('Initial time left:', initialTimeLeft);
    setTimeLeft(initialTimeLeft);

    // Update every second
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      console.log('Updated time left:', newTimeLeft);
      setTimeLeft(newTimeLeft);
    }, 1000);

    return () => clearInterval(timer);
  }, [blockedUntil]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 animate-fade-in">
        <div className="flex flex-col items-center text-center">
          <div className="bg-red-100 p-3 rounded-full mb-4">
            <Shield className="w-8 h-8 text-red-600" />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {isGlobalBlock ? t('globalTitle') : t('title')}
          </h1>
          
          <p className="text-gray-600 mb-6">
            {isGlobalBlock ? t('globalDescription') : t('description')}
          </p>

          <div className="bg-red-50 border border-red-100 rounded-xl p-4 w-full mb-6">
            <div className="flex items-center">
              <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0" />
              <p className="ml-3 text-sm text-red-700">
                {t('timeRemaining')}: <span className="font-mono font-medium">{timeLeft}</span>
              </p>
            </div>
          </div>

          <p className="text-sm text-gray-500">
            {t('contact')}
          </p>
        </div>
      </div>
    </div>
  );
}